import i18n from "i18next";
import Backend from "i18next-http-backend";
// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
import { initReactI18next } from "react-i18next";

export function initializeI18n() {
	i18n
		// load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
		// learn more: https://github.com/i18next/i18next-http-backend
		// want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
		.use(Backend)
		// pass the i18n instance to react-i18next.
		.use(initReactI18next)
		// init i18next
		// for all options read: https://www.i18next.com/overview/configuration-options
		.init({
			fallbackLng: "he",
			ns: ["stats-dashboard"],
			defaultNS: ["stats-dashboard"],
			debug: false,
			backend: {
				// for all available options read the backend's repository readme file
				loadPath: "/locales/{{lng}}/{{ns}}.json",
			},
			lng: "he",
			interpolation: {
				escapeValue: false, // not needed for react as it escapes by default
			},
		});
}
export default initializeI18n;
